import axios from 'axios';
import { useAuthStore } from '../stores/auth';

export const ApiBaseUrl = import.meta.env.VITE_APP_API_ROOT.substring(
  0,
  import.meta.env.VITE_APP_API_ROOT.indexOf('api/'),
);

const api = axios.create({
  baseURL: import.meta.env.VITE_APP_API_ROOT,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    Accept: 'application/json',
  },
});

api.interceptors.request.use(async (config) => {
  const auth = useAuthStore();

  const organizationId = auth.getOrganization.id;
  if (organizationId) {
    config.headers['X-Tenant-Id'] = organizationId;
  }

  // Add caretaker header to identify requests from caretaker app
  config.headers['X-Caretaker'] = 'true';

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401 && !window.location.href.match(/\/auth\//)) {
      window.location.href = '/auth/login';
    }

    return Promise.reject(error);
  },
);
export { api };